{
  "active": "Active",
  "inactive": "Inactive",
  "loading": "Loading",
  "logout": "Log out",
  "save": "Save",
  "edit": "Edit",
  "cancel": "Cancel",
  "retry": "Retry",
  "add": "Add",
  "import": "Import",
  "error": "An error has occured",
  "back": "Back",
  "yes": "Yes",
  "no": "No",
  "true": "Yes",
  "false": "No",
  "from": "From",
  "to": "To",
  "cpm": "CPM",
  "new": "New",
  "delete": "Delete",
  "confirm?": "Are you sure?",
  "irreversible": "This action can't be undone",
  "irreversible_with_name": "This action can't be undone, type \"{{name}}\" to delete",
  "locations": "Locations",
  "visits": "Visits",
  "traces": "Traces",
  "geovisits": "Geocoded Visits",
  "snapped_traces": "Snapped Traces",
  "wifi_events": "Wifi Events",
  "beacons": "Beacons",
  "geocodedVisits": "Geocoded Visits",
  "sync": "Sync",
  "pleaseSelect": "Please make a selection",
  "reset_password": "Reset password",
  "resend_confirmation_instructions": "Resend confirmation instructions",
  "or": "or",
  "remove": "remove",
  "ios": "iOS",
  "android": "Android",
  "countries": {
    "fr": "France",
    "gb": "United Kingdom",
    "it": "Italy",
    "be": "Belgium",
    "lu": "Luxembourg",
    "pt": "Portugal",
    "ch": "Switzerland",
    "de": "Germany",
    "es": "Spain",
    "ie": "Ireland",
    "nl": "Netherlands"
  },
  "languages": {
    "fr": "French",
    "en": "English"
  },
  "latitude": "Latitude",
  "longitude": "Longitude",
  "radius": "Radius",
  "preview": "Preview",
  "none": "None",
  "selectAll": "Select all",
  "all": "All",
  "selected": "selected",
  "menu": {
    "streams": "Streams",
    "extracts": "Extracts",
    "aggregates": "Aggregates",
    "audiences": "Audiences",
    "zones": "Zones",
    "aws_credentials": "AWS Access",
    "rights": "All rights reserved.",
    "organisation": "Organisation",
    "api": "API",
    "data_vendors": "Partners",
    "data_products": "Stream and Extract",
    "users": "Users",
    "dmps": "DMPs",
    "privacy": "Privacy",
    "awsCredentials": "AWS Credentials",
    "pakito": "Pakito",
    "devices": "Devices",
    "dashboard": "Dashboard",
    "apps": "Apps",
    "sdk": "Sdk",
    "sdk_documentation": "Documentation",
    "sdk_configuration": "Configuration",
    "sdk_credentials": "Credentials",
    "cmp": "Cmp",
    "motion_models": "Motion models",
    "cmp_configuration": "Configuration",
    "cmp_analytics": "Analytics",
    "publishers": "Publishers",
    "documentation": "Documentation",
    "configuration": "Configuration",
    "remote_parameter": "Remote parameters",
    "sdk_version": "SDK Version",
    "cmp_consent_request_layouts": "Layout",
    "finance": "Finance",
    "dev": "Dev tool",
    "geocode_tools": "Geocode tool",
    "page_elements": "Page element",
    "services": "Services",
    "applications": "Applications",
    "industries": "Industries"
  },
  "table": {
    "elementsCount": "Showing {{firstElement}} to {{lastElement}} of {{totalElements}} items",
    "show": "Show",
    "entries": "entries",
    "search": "search"
  },
  "users": {
    "tabName": "Users",
    "tableName": "Users",
    "new": "New user",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "company": "Company",
    "lastConnection": "Last connection",
    "createdAt": "Created at",
    "role": "Role",
    "phoneNumber": "Mobile phone number",
    "missingPhone": "The user doesn't have a phone number",
    "roles": "Roles",
    "impersonate": "Impersonate",
    "subscribedToSdkVersionNewsletter": "Subscribed to new version newsletter?"
  },
  "privacy": {
    "tabName": "Privacy",
    "general": "General",
    "isIab": "Are you a member of the TCF?",
    "selectVendor": "Please select your entity",
    "purposes": "Purposes",
    "purpose": "Purpose",
    "specialFeature": "Special Feature",
    "privacyPolicy": "Privacy Policy URL",
    "geomedia": "Use data for advertising purposes",
    "geodata": "Use data for analytics purposes"
  },
  "awsCredentials": {
    "tabName": "AWS Credentials",
    "creds": "AWS Credentials",
    "delete_value": "supprimer moi",
    "general": "Credential list",
    "new": "New AWS Credentials",
    "deletePlaceholder": "Please enter \"Delete\" to delete",
    "createAlert": {
      "title": "Impossible",
      "text": "You cannot have more than two credentials active at the same time"
    },
    "validation_message": "To delete type in the following field"
  },
  "devices": {
    "tabName": "Devices",
    "id": "Id",
    "idfa": "MAID",
    "app": "App",
    "active": "Active",
    "enable": "Enabled",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "InactivatedAt": "Inactivated at",
    "lastRequest": "Last request",
    "appVersion": "App version",
    "sdkVersion": "SDK version",
    "locationStatus": "Location status",
    "locationAutorized": "Location authorized",
    "locationMode": "Location mode",
    "deviceModel": "Device model",
    "systemVersion": "System version",
    "lang": "Language",
    "backgroundLocationEnabled": "Background location enabled",
    "adTracking": "Ad tracking",
    "cmp": "Cmp",
    "isCmp": "Is cmp",
    "cmpMode": "Cmp mode",
    "sptVendorConsent": "Singlespot vendor consent",
    "geomediaConsent": "Geomedia consent",
    "geoDataConsent": "Geodata Consent",
    "iabConsentString": "IAB consent string",
    "addToMonitored": "Monitor",
    "remoteParams": "Remote parameters",
    "general": "General",
    "EnabledHistory": "Enabled history",
    "LocationStatusHistory": "Locations status history",
    "LocationAuthorizedHistory": "Location authorized history",
    "SptVendorConsentHistory": "Singlespot vendor consent history",
    "MediaConsentHistory": "Media consent history",
    "DataConsentHistory": "Data consent history",
    "version": "Versions",
    "requests": "Requests",
    "monitored": "Monitored",
    "editToMonitored": "Edit monitored"
  },
  "geography": {
    "tabName": "Geography"
  },
  "analytics": {
    "tabName": "Analytics",
    "dataByDay": "Daily data",
    "table": {
      "events": "Events D-1",
      "daily_users": "Daily users D-1",
      "events_per_user": "Events per user D-1",
      "monthly_users": "MAU",
      "mtd_users": "MTD users",
      "avg_daily_users": "Avg DAU"
    }
  },
  "app": {
    "tabName": "Apps",
    "app_version": "App Version",
    "sdk_version": "SDK Version",
    "sdk_versions": "SDK Versions",
    "environment": "Environment",
    "test_date": "Test date",
    "production_date": "Production date",
    "cmp_approved": "CMP approved",
    "cmp_name": "CMP",
    "isCmp": "is CMP?",
    "testedAt": "Tested at",
    "productionAt": "Production at",
    "actions": {
      "cmp_analytics": "CMP Analytics",
      "admin": "Admin",
      "remote_params": "SDK Remote Parameters",
      "cmp_configuration": "CMP Configuration"
    },
    "general": {
      "tabName": "General",
      "general": "CMP Approval",
      "sdk_version": "SDK version",
      "app_version": "App version",
      "cmp_approval": "CMP approval"
    },
    "admin": "Admin",
    "enabled": "Enabled",
    "created_at": "Created at",
    "is_cmp": "Singlespot CMP",
    "cmp_approved_at": "CMP approved at",
    "cmp_approved_by": "CMP approved by",
    "test_sdk_date": "SDK version test date",
    "test_sdk_version": "Tested SDK version",
    "prod_sdk_date": "SDK version production date",
    "prod_sdk_version": "Production SDK version",
    "test_app_date": "App version test date",
    "prod_app_version": "Production App version",
    "test_app_version": "Tested App version",
    "prod_app_date": "App version production date",
    "tracked": "Tracked requests",
    "cmp_approved_app_version": "Affected App version",
    "cmp_approved_and_above": "Apply to subsequent versions",
    "remoteConfiguration": {
      "WithABGroup": "add A/B deployment",
      "ABRatioTitle": "Percent",
      "ABRatioPlaceholder": "A/B deployment ratio",
      "ABDeploy": "A/B deployment"
    },
    "deletePlaceholder": "Confirm by typing, \"confirm deletion\"",
    "confirm": "confirm deletion"
  },
  "sdk": {
    "tabName": "SDK"
  },
  "layout": {
    "tabName": "Layout"
  },
  "vendor": {
    "tabName": "Vendors"
  },
  "consent": {
    "tabName": "Consent"
  },
  "dataVendor": {
    "new": "New Partner",
    "name": "Name",
    "bucket": "Bucket",
    "cmp_vendor": "CMP Vendor",
    "cmp_vendor_id": "CMP Vendor",
    "publisher_id": "Editor",
    "industry": "Industry",
    "industry_id": "Industry",
    "environment": "Environment",
    "billing_start_date": "Billing start date",
    "contact_email": "Contact email",
    "contact_phone_number": "Phone number",
    "publishers": "Publishers",
    "whitelisted_publisher": "Allowed only to publishers",
    "blacklisted_publisher": "Exclude publishers",
    "blacklist": "Strategy",
    "exclude": "Exclude",
    "only": "Only",
    "index": "Partners",
    "cpm": "Billing",
    "general": "General",
    "stream": "Streams",
    "extractions": "Extracts",
    "vendorPublisherMissing": "You should choose either a vendor or a publisher",
    "vendorBlackList": "You must select a strategie wi publisher limit",
    "isPublisher": "Data Vendor is a Publisher",
    "selectPublisher": "Please select the publisher",
    "publisherScope": "Publisher Scope",
    "hasPublisherScope": "Enable Publisher Scoping",
    "max_users": "Maximum Billed Users",
    "billingModel": "Billing Model",
    "flat_fee": "Amount",
    "privacy": "Privacy",
    "contact": "Contact",
    "billing": "Billing",
    "emptySection": "This section is empty",
    "reset_creds": "Reset AWS Creds",
    "users": "Users",
    "finalized": "Finalized",
    "wifiNetwork": "Wifi networks",
    "terminated_at": "Terminated at",
    "optOut": "Opt-out",
    "withOptOut": "With opt-out ?",
    "dataVendor": {
      "delete_with_extracts_warning": "This vendor has existing extract files in {{s3_prefixes}}, deleting it will delete them as well"
    }
  },
  "streams": {
    "tabName": "Streams"
  },
  "stream": {
    "tabName": "Stream",
    "api": {
      "title": "API",
      "environment": "Environment"
    },
    "environment": "Environment",
    "new": "New data stream",
    "name": "Name",
    "general": "General information",
    "startDate": "Start date",
    "endDate": "End date",
    "nameText": "If left empty, your stream will be named 'Default' and will appear at the root of your bucket. You can only have one 'Default' stream.",
    "endDateText": "End date can be left empty, your stream will just be active until you set it otherwise.",
    "device": "Devices",
    "idfaRequired": "IDFA or GAID required",
    "now": "Now",
    "startDateText": "If left blank, your stream will start as soon as you activate it.",
    "backgroundRequired": "Filter devices which send less data",
    "backgroundRequiredText": "If set to true, we will remove from your stream devices that send less data.",
    "os": "Operating Systems",
    "anyOs": "iOS & Android",
    "homeRequired": "Only devices with a home",
    "workRequired": "Only devices with a work",
    "consent": "Consent",
    "dataTypes": "Data types",
    "virtual": "Virtual",
    "geography": {
      "blockTitle": "Geographic filters",
      "allEventsSection": "Events",
      "homeSection": "Home",
      "workSection": "Work",
      "filter": "Apply a geographical filter",
      "useExistingZone": "Use existing zone or create a new one",
      "homeFilter": "Apply a geographical filter to the home place of devices",
      "workFilter": "Apply a geographical filter to the work place of devices",
      "zones": "Choose zones",
      "useExisting": "Use an existing zone",
      "createNewZone": "Create a new zone",
      "trace_filter_type": {
        "start": "Start",
        "end": "End",
        "startorend": "Start or end",
        "intersect": "Wherever"
      },
      "trace_filter_type_text": "For traces only"
    },
    "publisherFilter": {
      "global": "Publishers filtered globally",
      "globalByPass": "Bypass global filter",
      "industry": "Publisher filter on industry level",
      "vendor": "Publishers filtered on vendor level",
      "productFilter": "Use specific publisher filter for this stream",
      "dataProduct": "Specific stream filter"
    },
    "column_mapping": {
      "title": "Column mapping"
    },
    "field_filter": {
      "wysiwyg": "Guided",
      "raw": "Raw",
      "property": "Property",
      "forbidden_values": "Forbidden values",
      "regex": "Use Regular expression",
      "forbid_null": "Forbid null value",
      "accepted_values": "Accepted values",
      "negate": "Not matching",
      "not_negate": "Matching",
      "matching": "Behavior"
    }
  },
  "publisherFilter": {
    "tabName": "Publishers filter"
  },
  "extracts": {
    "tabName": "extracts"
  },
  "audiences": {
    "tabName": "audiences"
  },
  "extract": {
    "tabName": "Extract",
    "new": "New data extract",
    "name": "Name",
    "general": "General information",
    "startDate": "Start date",
    "endDate": "End date",
    "nameText": "If left empty, your extract will be named 'Default' and will appear at the root of your bucket. You can only have one 'Default' extract.",
    "endDateText": "End date can be left empty, your extract will just be active until you set it otherwise.",
    "device": "Devices",
    "idfaRequired": "IDFA or GAID required",
    "now": "Now",
    "startDateText": "If left blank, your extract will start as soon as you activate it.",
    "backgroundRequired": "Filter devices which send less data",
    "backgroundRequiredText": "If set to true, we will remove from your extract devices that send less data.",
    "os": "Operating Systems",
    "anyOs": "iOS & Android",
    "homeRequired": "Only devices with a home",
    "workRequired": "Only devices with a work",
    "consent": "Consent",
    "dataTypes": "Data types",
    "virtual": "Virtual",
    "monitor": "Monitor",
    "run": "Run",
    "geography": {
      "blockTitle": "Geographic filters",
      "allEventsSection": "Events",
      "homeSection": "Home",
      "workSection": "Work",
      "filter": "Apply a geographical filter",
      "useExistingZone": "Use existing zone or create a new one",
      "homeFilter": "Apply a geographical filter to the home place of devices",
      "workFilter": "Apply a geographical filter to the work place of devices",
      "zones": "Choose zones",
      "useExisting": "Use an existing zone",
      "createNewZone": "Create a new zone",
      "trace_filter_type": {
        "start": "Start",
        "end": "End",
        "startorend": "Start or end",
        "intersect": "Wherever"
      },
      "trace_filter_type_text": "For traces only"
    }
  },
  "extract_monitor": {
    "tabName": "Monitor"
  },
  "information": {
    "tabName": "Informations"
  },
  "zone": {
    "new": "New zone",
    "general": "General information",
    "save": "Do you want to save this zone independently from this stream?",
    "name:": "Name",
    "filterType": "Type",
    "adminBoundaries": "Administrative boundaries (countries, regions, cities, ...)",
    "country": "Countries",
    "region": "Regions",
    "department": "Departments",
    "postcode": "Cities / postcodes",
    "iris": "IRIS (2019)",
    "geojson": "Geojson",
    "coordinates": {
      "title": "Coordinates",
      "noData": "Vous n'avez aucune donnée, cliquez sur le bouton ci-dessous ou déposez un fichier",
      "defaultRadius": "Default radius",
      "defaultRadiusText": "in meters",
      "radiusText": "in meters - if left empty, the default radius will apply",
      "key": "Identifiant",
      "keyText": "Can be a string or a number",
      "add": "Add a coordinate",
      "edit": "Edit a coordinate",
      "importTitle": "Import from file",
      "importDescription": "Drop a file or click to select. *.csv only",
      "hasHeader": "Does this file have a header?",
      "columnSelection": "Choose which column refers to which attribute"
    }
  },
  "adminBoundaries": {
    "level0": "Countries",
    "level1": "Regions",
    "level2": "Departments",
    "level3": "Cities",
    "level4": "IRIS"
  },
  "aggregate": {
    "tabName": "Aggregation",
    "group_by": "Group by",
    "useAggregate": "Use aggregation",
    "metrics": "Metrics",
    "spt_id_count": "Number of devices",
    "events_count": "Number of events",
    "id": "Identifiant"
  },
  "delete_confirmation": "Do you really want to delete?",
  "admin": {
    "tabName": "admin"
  },
  "custom_filter": {
    "title": "Custom filter",
    "name": "Name",
    "type": "Type",
    "params": "Body",
    "add": "Add a custom filter"
  },
  "billing": {
    "flat": "Flat fee",
    "cpm": "CPM",
    "cpm_range": "Ranged CPM",
    "model": "Model"
  },
  "audience_scope": {
    "tabName": "Audience limit",
    "audiences": "Audiences",
    "audience": "Audience",
    "placeholder": "Chose an audience",
    "exclusion": "Audience to exclude?"
  },
  "audience": {
    "tabName": "Audience",
    "new": "New audience"
  },
  "toast": {
    "created": "Successfully created",
    "updated": "Successfully updated",
    "deleted": "Successfully deleted",
    "sync": "Synchronize",
    "credentialsSent": "Credentials sent",
    "unauthorized": "Unauthorized",
    "run": "Running"
  },
  "dataByDay": {
    "title": "Data by day",
    "devices": "Actif devices",
    "geolocatedDevices": "Geolocated devices",
    "geolocatedDevicesConsented": "Consented geolocated devices",
    "optIn": "Geolocated opt-in",
    "consent": "Consent",
    "globalOptIn": "Global opt-in",
    "consented_devices": "Consented devices",
    "loc_consented_devices": "Geolocated consented devices",
    "geolocated_devices_consented": "Geolocated consent devices",
    "newDevices": "New devices"
  },
  "user": {
    "guest": "Guest",
    "member": "Member",
    "admin": "Admin"
  },
  "dataVendors": {
    "send_aws": "Create creds"
  },
  "publisher": {
    "new": "New publisher",
    "name": "Name",
    "username": "Username",
    "password": "Password",
    "devices": "Devices",
    "admin": "Admin",
    "optIn": "Opt-in",
    "authorizedGeoloc": "Authorized geolocation",
    "consent": "Consent",
    "consentCount": "Consents",
    "deviceByOs": "Devices by Os",
    "geolocatedDeviceByOs": "Geolocated devices by os",
    "locationOptInByOs": "Location opt-in by os",
    "app": {
      "tabName": "Apps",
      "name": "Name",
      "os": "OS",
      "environment": "Environnement",
      "production_sdk": "Production SDK",
      "test_sdk": "Test SDK",
      "cmp": "CMP",
      "title": "Apps",
      "locations": "Location D-1",
      "locations_uu": "Locations DAU",
      "locations_uu_30_days": "Locations MAU",
      "consent": "Consent",
      "consent_rate": "Consent rate"
    },
    "vendorConsentByOs": "Vendor consent by os",
    "optInPerOs": "Consent By Os - All Devices",
    "environment": "Environment",
    "status": "Status",
    "test_date": "Test date",
    "beacon_mode": "Beacon mode",
    "id": "Id",
    "created_at": "Created At",
    "production_date": "Production date",
    "cmp_access": "Access to CMP configuration",
    "has_devices_view": "Can view devices",
    "billing_entity": "Billing Entity",
    "rev_sharing": "Revenue sharing",
    "cpm": "pricing",
    "billing_manager": "Billing manager",
    "model": "Billing model",
    "monthly_mrg": "Monthly MRG",
    "billing_address": "Billing address",
    "cpm_equivalent": "CPM Equivalent",
    "daily_data": "Daily Data",
    "location_status": "Locations status",
    "cpmValueInvalid": "Invalid Value",
    "cpmToValidation": "Must by greater than \"from\"",
    "enabled": "Enabled?",
    "default_beacon_mode": "Default Becon mode",
    "can_configure_cmp": "Can configure CMP?",
    "rev_share": "Revenue sharing",
    "production_threshold": "Production threshold",
    "maus_by_location_status": "MAU by locations status",
    "actions": {
      "credentials": "Credentials",
      "cmp_configuration": "CMP Configuration",
      "cmp_analytics": "CMP Analytics",
      "sdk_configuration": "SDK Configuration",
      "sdk_idfa": "IDFA Request Configuration",
      "remote_params": "SDK Remote Parameters",
      "revenues": "Revenues",
      "users": "Users",
      "admin": "Admin",
      "configuration": "Configuration"
    },
    "general": {
      "tabName": "General",
      "general": "General Information",
      "billing": "Billing",
      "exclusiveDevices": "Exclusive Devices"
    },
    "apps": {
      "tabName": "Applications"
    },
    "credentialTester": {
      "iconText": "Test connection"
    },
    "consentAllDevices": "Consent all devices",
    "location_authorized_devices": "location authorized devices",
    "optInLocalisationPerOs": "OptIn localisation per os",
    "vendorConsent": "Vendor Consent",
    "revenues": "Revenues",
    "dataByDay": {
      "newDevices": "New device",
      "devices": "Device",
      "geolocatedDevices": "Geolocated device",
      "optIn": "OptIn"
    },
    "is_terminated": "Is terminated ?",
    "terminated_at": "Terminated at"
  },
  "enabled": "Enabled",
  "disabled": "Disabled",
  "general": {
    "tabName": "General"
  },
  "version": {
    "tabName": "Versions",
    "device_per_sdk_version": "Devices per SDK version",
    "device_per_os_version": "Devices per OS version",
    "device_per_app_version": "Devices per app version",
    "device_per_sdk_version_evolution": "Evolution of devices per SDK version",
    "device_per_os_version_evolution": "Evolution of devices by OS version",
    "device_per_app_version_evolution": "Evolution of devices by app version",
    "location_status_per_os_version": "Location Status per OS version"
  },
  "apps": {
    "tabName": "Apps",
    "password": "Password"
  },
  "creds": {
    "api_key": "API Key",
    "secret": "Secret"
  },
  "fr": {
    "tabName": "French"
  },
  "en": {
    "tabName": "English"
  },
  "pageElement": {
    "index": "Content",
    "name": "name",
    "label": "label",
    "translate": "translates"
  },
  "requests": {
    "tabName": "Requests"
  },
  "map": {
    "tabName": "Map"
  },
  "monitoredDevice": {
    "editTitle": "Add a description to the device",
    "description": "Description",
    "user": "User"
  },
  "stats": {
    "devices": "Acive devices",
    "geolocated_devices": "Geolocated devices",
    "opt_in_geolocated_devices": "Geolocated Opt-in",
    "consent": "Consent",
    "consent_rate": "Consent (%)",
    "prev_locations_uu": "Location D-1",
    "locations_dau": "Locations DAU",
    "locations_uu_30": "Locations MAU",
    "acitve": "Active",
    "inactive": "Inactive",
    "background_location_enabled": "Background location enbaled"
  },
  "locationRequestConfig": {
    "tabName": "Location request",
    "config": "Configuration",
    "default_config": "Default configuration",
    "inherited": "inherited",
    "askIfNoConsent": "Ask for location permission even if no consent is granted",
    "iosAskMode": "Location request mode",
    "askMinDays": "Minimum number of days before the first location request",
    "askMinLaunches": "Minimum number of launches before the first location request",
    "numberMaxRetry": "Maximum number of retries",
    "retryMinDays": "Minimum number of days between two location requests",
    "retryMinDaysSettings": "Minimum number of days between two location requests if system request was denied",
    "retryMinLaunches": "Minimum number of launches between two location requests",
    "retryMinLaunchesSettings": "Minimum number of launches between two location requests if system request was denied",
    "popupOnlyForRetry": "Only display this popup in case of retry",
    "usePopup": "Display a custom SDK popup before system location request"
  },
  "idfaRequestConfig": {
    "tabName": "IDFA request (iOS)",
    "config": "Configuration",
    "default_config": "Default configuration",
    "inherited": "inherited",
    "askIfNoConsent": {
      "title": "Ask for advertiser identification permission even if no consent is granted",
      "tooltip": "Indicates if you want to request advertiser identification even if no consent was granted to advertiser identification based purposes; <br><br> If advertiser identification data is only used by Singlespot, you can choose 'No', but if any other service of your app uses it, you must keep the default value 'Yes'. <br><br> This setting will only be used if you have initialised the SDK with the IDFARequestMode 'serverBased'."
    },
    "askMinDays": {
      "title": "Minimum number of days before the first advertiser identification request",
      "tooltip": "For example, if you choose '2', the advertiser identification request will be displayed at least 2 days after the first launch. <br><br> If you want it to be displayed at first launch, set this value to '0'. <br><br> If case of conflict with the minimum number of launches set below, the first threshold reached will be taken into account. <br><br> This setting will only be used if you have initialised the SDK with the IDFARequestMode 'serverBased'."
    },
    "askMinLaunches": {
      "title": "Minimum number of launches before the first advertiser identification request",
      "tooltip": "For example, if you choose '2', the advertiser identification request will not be displayed for the first 2 launches, ie. it will be displayed at the 3rd launch. <br><br> If you want it to be displayed at first launch, set this value to '0'. <br><br> If case of conflict with the minimum number of days set above, the first threshold reached will be taken into account. <br><br> This setting will only be used if you have initialised the SDK with the IDFARequestMode 'serverBased'."
    },
    "numberMaxRetry": {
      "title": "Maximum number of retries",
      "tooltip": "For example, if you choose '0', the popup will be displayed only once, and never retried. <br><br> If you choose '1', the popup could be displayed twice: one initial attempt and one retry, if the first attempt was denied."
    },
    "retryMinDays": {
      "title": "Minimum number of days between two IDFA requests",
      "tooltip": "For example, if you choose '2', the next popup will be displayed at least 2 days after the previous one. <br><br> The minimum value allowed is '1'. <br><br> If case of conflict with the minimum number of launches set below, the first threshold reached will be taken into account."
    },
    "retryMinDaysSettings": {
      "title": "Minimum number of days between two IDFA requests if system request was denied",
      "tooltip": "Same as the minimum number of days above, but in case the user has already seen the system request and denied it. <br><br> If the user accepts this popup, he will be redirected to the system settings of your app in order to activate ad tracking."
    },
    "retryMinLaunches": {
      "title": "Minimum number of launches between two IDFA requests",
      "tooltip": "For example, if you choose '2', a popup will be displayed every other launch of your app, until the maximum number of retries is reached. <br><br> The minimum value allowed is '1'. <br><br> If case of conflict with the minimum number of days set above, the first threshold reached will be taken into account."
    },
    "retryMinLaunchesSettings": {
      "title": "Minimum number of launches between two IDFA requests if system request was denied",
      "tooltip": "Same as the minimum number of launches above, but in case the user has already seen the system request and denied it. <br><br> If the user accepts this popup, he will be redirected to the system settings of your app in order to activate ad tracking."
    },
    "popupOnlyForRetry": {
      "title": "Only display this popup in case of retry",
      "tooltip": "Only display this popup if the user has denied access to his Advertising ID. If he accepts this popup, he will be redirected to the system settings of your app."
    },
    "usePopup": {
      "title": "Display a custom SDK popup before system IDFA request",
      "tooltip": "Indicates if you wish to display a popup before system IDFA request, allowing your users to better understand why you ask for it, and ultimately increase opt-in rates."
    }
  },
  "sdkDoc": {
    "android": {
      "tabName": "android"
    },
    "ios": {
      "tabName": "iOS"
    },
    "cordova": {
      "tabName": "Cordova"
    },
    "reactNative": {
      "tabName": "React Native"
    },
    "tcfv2Migration": {
      "tabName": "TCF v2 Migration"
    },
    "unity": {
      "tabName": "Unity"
    },
    "flutter": {
      "tabName": "Flutter"
    }
  },
  "cmp": {
    "popup": {
      "tabName": "Popup",
      "configBlockTitle": "General information",
      "publisherName": "Name of the entity collecting the consents",
      "privacyPolicyUrl": "Privacy policy URL",
      "dpoEmail": "DPO email",
      "dpoPostalAddress": "Complete mailing address of the DPO",
      "languages": "Languages",
      "defaultLanguage": "Default language",
      "allowRetry": "Allow retry",
      "optinValidity": "Consent validity duration (in months)",
      "includeAllIabVendors": "Include all IAB vendors",
      "contentBlockTitle": "Content",
      "layoutBlockTitle": "Design",
      "general": "General",
      "dpoContact": "DPO contact",
      "retry": "Retry",
      "linkColor": "Link color",
      "buttonColor": "Buttons color",
      "activeSwitchColor": "Switches color",
      "headerColor": "Logo background color",
      "backgroundColor": "Background color",
      "textColor": "Text color",
      "fontUrl": "CDN link of CSS file loading font",
      "fontUrlText": "CSS file containing @font-face as font-weight 400 and 700 (normal and bold)",
      "fontSelector": "Font selector",
      "fontSelectorText": "Roboto for the Roboto font for example. In case of failure: Helvetica, Arial, sans-serif",
      "defaultTcfV2ConsentRequestLayoutVersion": "Layout version",
      "logo": "Logo",
      "logoText": "Allowed format: .png",
      "headImageBuffer": "Head image buffer"
    },
    "vendors": {
      "tabName": "Vendors",
      "addVendor": "Add vendor",
      "selectVendor": "Choose a vendor",
      "createVendor": "Create a new vendor",
      "name": "Vendor name",
      "policyUrl": "Privacy policy URL",
      "key": "Key",
      "purposes": "Purposes"
    },
    "purposes": {
      "tabName": "Purposes",
      "addPurpose": "Add purpose"
    },
    "apps": {
      "tabName": "Applications",
      "addAppGroup": "New app group"
    },
    "appGroups": {
      "name": "Nom",
      "bundleIdMatchers": "Bundle IDs",
      "isDefault": "Default group",
      "os": "Operating system",
      "selectOs": "Choose an OS",
      "edit": "Edit"
    },
    "appGroup": "App group",
    "purpose": "Purpose",
    "stack": "Stack",
    "special_feature": "Special feature",
    "name": "Name",
    "description": "Description",
    "descriptionLegal": "Legal description",
    "iabId": "IAB ID",
    "iabType": "IAB Type",
    "legIntAllowed": "Allow legitimate interest",
    "privacyPolicyUrl": "Privacy policy URL",
    "legInt": "Legitimate interest",
    "title": "Title",
    "body": "Body",
    "key": "Key",
    "preview": {
      "output": "Output",
      "action": "Action :",
      "iabString": "IAB Consent String:",
      "singlespot": "Singlespot",
      "iab": "IAB",
      "purposes": "Purposes",
      "vendors": "Vendors",
      "nothingToDisplay": "Nothing to display",
      "allowedPurposeIds": "Allowed purposes IDs:",
      "allowedVendorIds": "Allowed vendors IDs:",
      "specialFeatureIds": "Allowed special features IDs:",
      "legIntPurposeIds": "Allowed purpose IDs for legitimate interest:",
      "onAccept": "Accept all",
      "onRefuse": "Deny all",
      "onSave": "Save",
      "onCancel": "Cancel"
    },
    "consentRequestLayouts": "Consent request layout",
    "analytics": {
      "kpis": {
        "displayRate": "Displayed",
        "consentRate": "Consent",
        "devices": "Devices",
        "consentedDevices": "Consents",
        "devicesWithCmpPresented": "Consent requests"
      },
      "dataByDay": {
        "title": "Daily data",
        "daily": "Daily",
        "cumulated": "Cumulated",
        "table": "Table"
      },
      "metrics": {
        "devices": "Devices",
        "devicesWithCmpPresented": "Consent requests",
        "presentationRate": "Display rate",
        "consentedDevices": "Consents",
        "consentRate": "Consent rate",
        "dailyCmpPresented": "Daily consent requests",
        "dailyConsents": "Daily consents",
        "dailyConsentRate": "Daily consent rate",
        "dailyAverageDisplayRank": "Daily average display rank",
        "productionDate": "Production date",
        "testDate": "Test date",
        "name": "Name",
        "productionSdk": "Production SDK",
        "testSdk": "Test SDK",
        "environment": "Environment",
        "averageDisplayRank": "Average display rank",
        "iabId": "IAB ID"
      },
      "tcfVersion": "TCF Version",
      "accept": "Accept",
      "deny": "Deny",
      "save": "Save",
      "consentsByOutput": "Output (1st presentation)",
      "consentsByOs": "Consent by OS",
      "consentRequestsByLang": "Consent requests by language",
      "consentsByLang": "Consent by language (1st presentation)",
      "consentRequestsByRank": "Consent requests by display rank",
      "consentsByRank": "Consent by display rank",
      "consentRequestsByLayout": "Consent requests by layout version",
      "consentRequestsByLayoutByDay": "Evolution of consent requests by layout version"
    },
    "unconfigured": {
      "title": "Not configured",
      "message": "It seems you don't have access to the CMP yet, please contact your account manager to request access."
    }
  },
  "publisherInvoice": {
    "title": "Invoice",
    "from": "from",
    "to": "to",
    "mau": "Monthly Active Users",
    "price": "Total (excl. tax)",
    "cpm": "CPM",
    "fixed": "Fixed price",
    "prorata": "Prorata temporis",
    "mrg": "Minimum revenue guarantee",
    "revshare_basis": "Revenue sharing basis",
    "revshare": "Revenue sharing rate",
    "revshare_amount": "Revenue sharing",
    "details": "Details by OS and app",
    "ios": "iOS",
    "android": "Android",
    "confirmFinalize": "You are about to finalize this invoice. Are you sure?",
    "confirmDeletion": "You are about to delete this invoice. Are you sure?",
    "invoicingRequest": "Invoicing request",
    "finalize": "Finalize",
    "users": "Devices",
    "finalized": "AAF finalized!",
    "mbu": "Monthly Billed User",
    "prorata_temporis": "prorata temporis"
  },
  "invoice": "Invoice",
  "invoices": {
    "mrg": "MRG",
    "rev_share_amount": "Rev Share",
    "publisher_amount": "Total Publisher",
    "data_vendor_amount": "Income",
    "gross": "Gross margin",
    "status": "status",
    "amount": "Amount"
  },
  "incomes": {
    "final": "Final",
    "draft": "Draft"
  },
  "download": "Downlaod",
  "vendors": {
    "tabName": "Vendors"
  },
  "publishers": {
    "tabName": "Publishers"
  },
  "dashboard": {
    "sdkVersion": "SDK Version"
  },
  "remoteConfiguration": {
    "sub": "Remote Configuration",
    "remoteParameters": "Remote parameters",
    "key": "KEY",
    "value": "VALUE"
  },
  "defaultConfiguration": {
    "tabName": "Default configuration"
  },
  "iosConfiguration": {
    "tabName": "iOS configuration"
  },
  "androidConfiguration": {
    "tabName": "Andorid configuration"
  },
  "RemoteConfiguration": {
    "title": "Remote configuration"
  },
  "sdkVersion": {
    "version": "Version",
    "os": "Os",
    "environment": "Environment",
    "changeLog": "Change log",
    "testedAt": "Tested at",
    "productionAt": "Production at",
    "newsletter": "Newsletter SDK",
    "newsletter_send": "Newsletter sent"
  },
  "oauth": {
    "title": "Manage your applications",
    "open": "Open configuration",
    "popup": "To get the OAuth configuration please make sure to allow popup window and click on the button above.",
    "credentials": "Credentials",
    "error": "Error : %{error}",
    "code": "code",
    "authorize": "Authorize",
    "application_uid": "application UID",
    "secret": "secret",
    "curl_command": "cURL command",
    "placeholder_code": "Authorize to get the code",
    "add": "Add application",
    "no_application": "No application found. Please add a new one to get your credentials.",
    "documentation": "Documentation"
  },
  "dataVendorInvoice": {
    "finalized": "Finalized"
  },
  "under_maintenance": "This page is under maintenance",
  "history": "History",
  "remoteConfigurationHistory": {
    "date": "Date",
    "key": "Key",
    "value": "Value",
    "comment": "Comment",
    "user": "Modified by"
  },
  "comment": "Comment",
  "industries": {
    "blacklistedPublisher": "Publishers not allowed",
    "form": {
      "name": "name"
    }
  },
  "dmp": {
    "deletePlaceholder": "Write \"Delete\"",
    "audiences": "Audiences",
    "form": {
      "name": "Name"
    },
    "push": "Push",
    "pushTaxonomy": "Push Taxonomy"
  },
  "motion_model": {
    "os": "Os",
    "model_file": "Model file",
    "training_at": "Training at",
    "title": "Motion model",
    "dragndrop": "Drag and drop"
  }
}
